import React, { useState, useEffect } from 'react';
import { Page, theme, Typo, PageHeaderLogo, PageBoxContent, PageContainerVCenter } from '../../ui';

import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import TestEnvironmentWarning from '../../components/TestEnvironmentWarning';
import { useTranslation } from 'react-i18next';
import { useHashLogin } from './hooks/useAuthActions';

const Auth = () => {
  const { t } = useTranslation();

  const [forgotPass, setForgotPass] = useState(false);

  const hashLogin = useHashLogin();

  useEffect(() => {
    if (window.location.search.split('welcome%3D')[1]) {
      const c2hash = window.location.search.split('welcome%3D')[1];

      hashLogin({ c2hash });
    }
  }, [hashLogin]);

  return (
    <Page backgroundColor={theme.colors.PRIMARY} fullheight={true}>
      <PageHeaderLogo marginBottom='1rem' />
      <PageContainerVCenter>
        <PageBoxContent>
          <TestEnvironmentWarning />
          <Typo.ContentSmallHeader>{forgotPass ? t('auth.forgotPassword') : t('auth.signIn')}</Typo.ContentSmallHeader>
          {forgotPass ? <ForgotPassword onCancel={() => setForgotPass(false)} /> : <Login onForgotPass={() => setForgotPass(true)} />}
        </PageBoxContent>
      </PageContainerVCenter>
    </Page>
  );
};

export default Auth;
